import { useEffect } from 'react'

interface UseToolSwitchResetsInput {
  activeItem: string
  setSelectedPenTool: (tool: string | null) => void
}

/** State that resets whenever the active tool changes. */
export function useToolSwitchResets({ activeItem, setSelectedPenTool }: UseToolSwitchResetsInput) {
  // Select-tool sections are deliberately not reset here: Object/Type/Photo are remembered per
  // selection (`usePropertiesPanelAutoOpenSection`) and Layout/Effects globally, so closing one
  // on a tool switch would be saved as if the user had collapsed it.

  // When switching to select tool, reset shapes tool state
  useEffect(() => {
    if (activeItem === 'select') {
      setSelectedPenTool(null)
    }
  }, [activeItem, setSelectedPenTool])
}
